import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { modalClasses } from "../../common/tailwindClassnames";

type SettingUpModalProps = {
    selectedProviderType: string,
    onCloseAndAddDestinations: MouseEventHandler,
    onCloseAndStayOnPage: MouseEventHandler;
}

const SettingUpModal = ({
    selectedProviderType,
    onCloseAndAddDestinations,
    onCloseAndStayOnPage
}: SettingUpModalProps) => {
    const { t } = useTranslation();
    return (
        <div className="absolute left-0 z-30">
            <div className="fixed top-0 left-0 right-0 h-screen bg-dark-gray dark:bg-neutral-gray-900 opacity-80 dark:opacity-90 transition-colors duration-300"
                onClick={onCloseAndStayOnPage}></div>
            <div className="relative flex justify-center w-screen h-screen opacity-100">
                <div className="z-20 flex flex-col bg-very-light-gray dark:bg-dark-gray w-1/3 h-fit shadow rounded-lg mt-12 transition-colors duration-300">
                    <div className="flex flex-row-reverse">
                        <button
                            type="button"
                            onClick={onCloseAndStayOnPage}
                            className="text-medium-gray dark:text-gray-lines bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white transition-colors duration-300"
                            data-modal-hide="authentication-modal"
                        >
                            <svg aria-hidden="true" className="w-7 h-7 text-off-black dark:text-white transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            <span className="sr-only">{t("Close Modal")}</span>
                        </button>
                    </div>
                    <div className="px-6 pb-6 lg:px-8 h-full">
                        <h2 className="text-xl mb-6 text-off-black dark:text-white text-[24px] transition-colors duration-300">Connection Ready!</h2>
                        <p className="text-secondary-gray dark:text-gray-lines text-md mb-[32px] text-[16px] transition-colors duration-300">Please wait for a few minutes while we work on processing your data sources.</p>
                        <p className="text-secondary-gray dark:text-gray-lines text-md mb-[32px] text-[16px] transition-colors duration-300">For more details on what to expect after configuring your connection, check out our Help Center documentation.</p>
                    </div>
                    <button className="font-bold bg-dark-green hover:bg-status-green text-white font-bold rounded px-7 py-2 w-fit mx-8 mb-8 transition-colors duration-300"
                        onClick={onCloseAndAddDestinations}>
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SettingUpModal;